import { ArrowUpRight, ShoppingBag } from "@phosphor-icons/react";
import { useLang } from "../../i18n";
import { fileUrl } from "../../lib/api";
import Chapter from "./Chapter";
import Reveal from "./Reveal";
import ScrollStrip from "./ScrollStrip";

export default function Rekomendasi({ shops }) {
    const { t } = useLang();
    return (
        <section id="gear" className="py-24 md:py-32 border-t border-racing-line bg-[#FBF9F5]" data-testid="gear-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <Chapter number="04" title={t.ch_gear_t} subtitle={t.ch_gear_s} />

                <Reveal className="mb-12 max-w-2xl">
                    <p className="text-base font-light text-racing-muted leading-relaxed">
                        {t.gear_desc}
                    </p>
                </Reveal>

                {shops.length === 0 ? (
                    <p className="text-racing-muted" data-testid="gear-empty">{t.gear_empty}</p>
                ) : (
                    <ScrollStrip testid="gear-strip">
                        {shops.map((s, i) => (
                            <Reveal key={s.id} delay={i * 0.05} className="shrink-0">
                                <a
                                    href={s.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`gear-card-${i}`}
                                    className="group block w-36 md:w-44 snap-start"
                                >
                                    <div className="relative w-full aspect-square border border-racing-line bg-racing-surface overflow-hidden">
                                        {s.thumb_url ? (
                                            <img
                                                src={fileUrl(s.thumb_url)}
                                                alt={s.name}
                                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                            />
                                        ) : (
                                            <div className="w-full h-full flex items-center justify-center">
                                                <ShoppingBag size={32} weight="duotone" className="text-racing-red/40" />
                                            </div>
                                        )}
                                        <span className="absolute top-2 right-2 bg-racing-red text-white p-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            <ArrowUpRight size={14} weight="bold" />
                                        </span>
                                    </div>
                                    <p className="mt-3 text-xs font-medium text-neutral-900 leading-snug line-clamp-2 group-hover:text-racing-red transition-colors duration-300">
                                        {s.name}
                                    </p>
                                    <p className="mt-1 text-[10px] uppercase tracking-[0.2em] text-racing-muted">{s.tag}</p>
                                </a>
                            </Reveal>
                        ))}
                    </ScrollStrip>
                )}
            </div>
        </section>
    );
}
